<template>
    <main class="authorization-content">
      <div class="location">
        <div class="location__content popup box bg-white">
          <form id="location-form" name="location-form" method="post">
            <div class="popup__header">
              <div class="popup__title section__title section__title_style3">Вход в личный кабинет</div>
              <div class="popup__logo svg-icon" aria-hidden="true">
                <svg role="img" width="63" height="24" aria-hidden="true">
                  <use xlink:href="#svg-logo-mobile"></use>
                </svg>
              </div>
            </div>
            <div class="popup__body">
              <div class="popup__descr section__description color-green">
                <p>Укажите ваш регион подключения услуг</p>
              </div>
              <div class="form-group">
                <div class="location__dropdown dropdown">
                  <input class="js-location-value" type="hidden" name="user-location" id="user-location" value="Нур-Султан">
                  <!-- For mobile only-->
                  <select class="btn location__select js-native-location-select d-none">
                    <option value="1">Актау</option>
                    <option value="2">Актобе</option>
                    <option value="3">Алматы</option>
                    <option value="4">Атырау</option>
                    <option value="5">Жамбыл</option>
                    <option value="6">Караганда</option>
                    <option value="7">Коктешау</option>
                    <option value="9">Костанай</option>
                    <option value="10">Кызылорда</option>
                    <option value="11">Нур-Султан</option>
                    <option value="12">Оскемен</option>
                    <option value="13">Павлодар</option>
                    <option value="14">Семей</option>
                    <option value="15">Центральный аппарат</option>
                    <option value="16">Шымкент</option>
                  </select>
                  <!-- For desktop only-->
                  <button class="btn location__select js-location-select" type="button" aria-label="Выбрать регион" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static"><span class="btn__text">Нур-Султан</span><span class="btn__icon svg-icon" aria-hidden="true">
                      <svg role="img" width="14" height="14" aria-hidden="true">
                        <use xlink:href="#svg-icon-arrow-next"></use>
                      </svg></span></button>
                  <div class="dropdown-menu">
                    <button class="btn location__select js-location-select" type="button" aria-label="Закрыть"><span class="btn__text">Нур-Султан</span><span class="btn__icon svg-icon" aria-hidden="true">
                        <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-arrow-next"></use>
                        </svg></span></button>
                    <ul class="list list_unstyled location__list">
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="1">Актау</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="2">Актобе</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="3">Алматы</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="4">Атырау</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="5">Жамбыл</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="6">Караганда</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="7">Коктешау</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="8">Костанай</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="9">Кызылорда</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region active js-location-region" type="button" data-value="10">Нур-Султан</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="11">Оскемен</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="12">Павлодар</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="13">Семей</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="14">Центральный аппарат</button>
                      </li>
                      <li class="list__item">
                        <button class="btn location__region js-location-region" type="button" data-value="15">Шымкент</button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="popup__footer">
              <button class="btn btn_default btn_white" type="submit">Войти</button>
            </div>
          </form>
        </div>
        <div class="location__img"><img src="images/content/map.png" alt="Карта"></div>
      </div>
    </main>
</template>